var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 7.17647,
    rx: 1.41176,
    ry: 1.5,
    transform: "rotate(90 12 7.17647)",
    fill: "#595A62"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 1.41176,
    ry: 1.5,
    transform: "rotate(90 12 12)",
    fill: "#595A62"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 16.8235,
    rx: 1.41176,
    ry: 1.5,
    transform: "rotate(90 12 16.8235)",
    fill: "#595A62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMoreIcon);
export default __webpack_public_path__ + "static/media/InactiveMoreIcon.9cde4e30f8a92205ecb1dde24c5adbd6.svg";
export { ForwardRef as ReactComponent };